import { render, staticRenderFns } from "./CmCopy.vue?vue&type=template&id=9cb1b430"
import script from "./CmCopy.vue?vue&type=script&lang=ts"
export * from "./CmCopy.vue?vue&type=script&lang=ts"
import style0 from "./CmCopy.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ModuleHeader: require('/app/components/base/ModuleHeader/ModuleHeader.vue').default,ImageComponent: require('/app/components/base/ImageComponent/ImageComponent.vue').default,Icon: require('/app/components/base/Icon/Icon.vue').default,RichText: require('/app/components/base/RichText/RichText.vue').default})
